import script from "./ProductDraftPreviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDraftPreviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./ProductDraftPreviewPanel.vue?vue&type=style&index=0&id=2fb1a26c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb1a26c"]])

export default __exports__